import { Route } from 'react-router-dom';
import { SittingScheduleList } from './list';
import { SittingScheduleShow } from './show';

export const SittingSchedulesRoute = (
  <Route path="schedules">
    <Route index element={<SittingScheduleList />} />
    <Route path=":id" element={<SittingScheduleShow />} />
  </Route>
);
